import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { MenuProvider } from './context/MenuContext';
import { CopyProvider } from './context/CopyContext';
import Login from "./components/login/Login";
import UserList from "./screen/user/List";
import UserInput from "./screen/user/Input";
import UserEdit from "./screen/user/Edit";
import UserConfirm from "./screen/user/Confirm";
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import ClientInput from "./screen/client/Input";
import ClientConfirm from "./screen/client/Confirm";
import ClientList from "./screen/client/List";
import ClientEdit from "./screen/client/Edit";
import ProjectInput from "./screen/project/Input";
import ProjectConfirm from "./screen/project/Confirm";
import ProjectEdit from "./screen/project/Edit";
import ProjectDetails from "./components/project/ProjectDetails"
import ProjectList from "./screen/project/List";
import ScheduleList from "./components/schedule/ScheduleList";
import ScheduleInput from "./screen/schedule/Input";
import ScheduleEdit from "./screen/schedule/Edit";
import ScheduleDownload from "./components/schedule/ScheduleDownload";
import CommentList from "./screen/comment/List"

function App() {

    return (

        <AuthProvider>
            <MenuProvider>
                <CopyProvider>
                    <Router>
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/scheduleList/:work_date" element={<ProtectedRoute><ScheduleList /></ProtectedRoute>} />
                            <Route path="/userConfirm" element={<ProtectedRoute><UserConfirm /></ProtectedRoute>} />
                            <Route path="/userList" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
                            <Route path="/userInput" element={<ProtectedRoute requiredAuthCode = "1"><UserInput /></ProtectedRoute>} />
                            <Route path="/userEdit/:id" element={<ProtectedRoute><UserEdit /></ProtectedRoute>} />
                            <Route path="/clientList" element={<ProtectedRoute><ClientList /></ProtectedRoute>} />
                            <Route path="/clientInput" element={<ProtectedRoute><ClientInput /></ProtectedRoute>} />
                            <Route path="/clientEdit/:id" element={<ProtectedRoute><ClientEdit /></ProtectedRoute>} />
                            <Route path="/clientConfirm" element={<ProtectedRoute><ClientConfirm /></ProtectedRoute>} />
                            <Route path="/projectInput" element={<ProtectedRoute><ProjectInput /></ProtectedRoute>} />
                            <Route path="/projectConfirm" element={<ProtectedRoute><ProjectConfirm /></ProtectedRoute>} />
                            <Route path="/projectEdit/:id" element={<ProtectedRoute><ProjectEdit /></ProtectedRoute>} />
                            <Route path="/projectDetails/:id" element={<ProtectedRoute><ProjectDetails /></ProtectedRoute>}/>
                            <Route path="/projectList" element={<ProtectedRoute><ProjectList /></ProtectedRoute>} /> 
                            <Route path="/scheduleInput/:work_date" element={<ProtectedRoute><ScheduleInput /></ProtectedRoute>} />
                            <Route path="/scheduleEdit/:id/:work_date" element={<ProtectedRoute><ScheduleEdit /></ProtectedRoute>} />
                            <Route path="/scheduleDownload/:id" element={<ProtectedRoute><ScheduleDownload /></ProtectedRoute>} /> 
                            <Route path="/comment" element={<ProtectedRoute><CommentList /></ProtectedRoute>} /> 
                            
                            <Route path="*" element={<Navigate to="/login" />} />
                        </Routes>
                    </Router>
                </CopyProvider>
            </MenuProvider>
        </AuthProvider >

    );
}

export default App;
